import { CoachSportStatusesEnum, CoachSportsInsertInput, SportsEnum } from 'types/generated/client';

export function getUpdatedCoachSports({
  userId,
  previousSports,
  newSports,
}: {
  userId: string;
  previousSports: SportsEnum[];
  newSports: SportsEnum[];
}): CoachSportsInsertInput[] {
  const newSet = new Set(newSports);
  const prevSet = new Set(previousSports);

  const addedOrRetained: CoachSportsInsertInput[] = newSports.map((sport) => ({
    userId,
    sport,
    status: CoachSportStatusesEnum.Active,
  }));

  const removed: CoachSportsInsertInput[] = [...prevSet]
    .filter((sport) => !newSet.has(sport))
    .map((sport) => ({
      userId,
      sport,
      status: CoachSportStatusesEnum.Inactive,
    }));

  return [...addedOrRetained, ...removed];
}
